import { useContext, useEffect, useState } from "react";

import { SegmentationContext } from "Contexts/Segmentation";

const useSegmentation = ({ configs } = {}) => {
  const { getProjects, getUsers } = useContext(SegmentationContext);

  const { pageType } = configs;

  const [projects, setProjects] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const states = {
    projects,
    selectedProjects,
    users,
    selectedUsers,
  };

  const seters = {
    setProjects,
    setSelectedProjects,
    setUsers,
    setSelectedUsers,
  };

  const stringifySegmentationState = () => {
    const states = {
      projects: selectedProjects,
      target_user_ids: selectedUsers,
    };

    const formated_states = {};

    for (const key in states) {
      const ids = states[key].map((item) => item?.id || item?.value);

      formated_states[key] = JSON.stringify(ids);
    }

    return formated_states;
  };

  const resetSelectedStates = () => {
    setSelectedProjects([]);
    setSelectedUsers([]);
    setProjects([]);
    setUsers([]);
  };

  const setDefaultSegmentation = async (data, configs) => {
    if (configs.noUse) return;

    const { projects, target_user_ids: users } = data;

    if (configs.useAll)
      configs = {
        useProjects: true,
        useUsers: true,
      };

    const segmentation = await setup({
      projects,
      users,
    });

    if (configs.useProjects && projects) {
      const projectsData = segmentation.projects.filter((project) =>
        projects.includes(project.id),
      );

      setSelectedProjects(projectsData.map((project) => project.id));
      setProjects(projectsData);
    }

    if (configs.useUsers && users) {
      const usersData = segmentation.users.filter((user) =>
        users.includes(user.id),
      );

      setSelectedUsers(usersData.map((user) => user.id));
      setUsers(usersData);
    }
  };

  const setup = async (states) => {
    const projects =
      pageType === "update" && states?.projects
        ? await getProjects(setProjects, selectedProjects)
        : [];

    const users =
      pageType === "update" && states?.users
        ? await getUsers(setUsers, [], selectedUsers)
        : [];

    return {
      projects,
      users,
    };
  };

  const useConfigs = {
    projectsConfig: {
      projects: projects,
      selectedProjects: selectedProjects,
      setSelectedProjects: setSelectedProjects,
      getProjects,
      setProjects: setProjects,
    },
    usersConfig: {
      users: users,
      selectedUsers: selectedUsers,
      setSelectedUsers: setSelectedUsers,
      getUsers,
      setUsers,
    },
  };

  const notUseConfig = {
    projectsConfig: {
      useProjects: false,
    },
    usersConfig: {
      useUsers: false,
    },
  };

  const setSegmentationConfig = ({ useProjects, useUsers, useAll, noUse }) => {
    if (!useAll)
      return {
        projectsConfig: useProjects
          ? useConfigs.projectsConfig
          : notUseConfig.projectsConfig,
        usersConfig: useUsers
          ? useConfigs.usersConfig
          : notUseConfig.usersConfig,
      };

    if (noUse)
      return {
        projectsConfig: notUseConfig.projectsConfig,
        usersConfig: notUseConfig.usersConfig,
      };

    return {
      projectsConfig: useConfigs.projectsConfig,
      usersConfig: useConfigs.usersConfig,
    };
  };

  useEffect(() => {
    if (pageType === "create") setup();
  }, []);

  return {
    states,
    seters,
    setSegmentationConfig,
    stringifySegmentationState,
    resetSelectedStates,
    setDefaultSegmentation,
  };
};

export default useSegmentation;
